<template>
      <div class="requirementCreate">
        <v-breadcrumbs>
          <v-breadcrumbs-item :exact="true" :to="{ name: 'home', params: {} }"
            >Home</v-breadcrumbs-item
          >
          <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
          <v-breadcrumbs-item :exact="true" :to="{ name: 'requirement', params: {} }">
          Requirement
          </v-breadcrumbs-item>
          <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
          <v-breadcrumbs-item :to="{ name: 'requirementCreate', params: {} }">
            Create Requirement
          </v-breadcrumbs-item>
        </v-breadcrumbs>

        <v-card>
          <v-card-title>Create Requirement</v-card-title>
          <v-card-text>
            <requirement-form></requirement-form>
          </v-card-text>
        </v-card>
      </div>
    </template>
    <script>
    import RequirementForm from './RequirementForm.vue';

    export default {
      name: 'requirement',
      components: {
        RequirementForm
      },
      created() {
        this.$emit("showParent", false);
      }
    }
    </script>
    